import axios from '@/services/axios';
import { ResponseData } from '@/types/root';
import { IUserFormOptions } from '@/types/user';

export function getUserInfo<T>(): Promise<ResponseData<T>> {
  return axios.request({
    url: '/mobile/ma/user',
    method: 'get'
  });
}

export function getReservations<T>(page: number = 1): Promise<ResponseData<T>> {
  return axios.request({
    url: `/mobile/ma/user/reservation?page=${page}`,
    method: 'get'
  });
}

export function getHistory<T>(page: number = 1): Promise<ResponseData<T>> {
  return axios.request({
    url: `/mobile/ma/user/history?page=${page}`,
    method: 'get'
  });
}

export function getSMSCode<T>(tel: string): Promise<ResponseData<T>> {
  return axios.request({
    url: '/mobile/ma/user/code',
    data: { tel },
    method: 'post'
  });
}

export function submitUserForm<T>(data: IUserFormOptions): Promise<ResponseData<T>> {
  return axios.request({
    url: '/mobile/ma/user/update',
    data,
    method: 'post'
  });
}
